import React, { useState } from 'react';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import { Step1Icon, Step2Icon, Step3Icon } from '../../Constant/Index';
const Tools = () => {
    const [id, setId] = useState(3);
    const [ShowData, ChangeShowData] = useState(8);
    const [BtnText, ChangeBtnText] = useState("Load More");
    let NameList = [
        {
            TheId: 1,
            TheName: "Incoterms",
        },
        {
            TheId: 2,
            TheName: "Converter/Tools",
        },
        {
            TheId: 3,
            TheName: "Glossary Of Terms",
        }
    ];
    let TotalData = [
        {
            ToolName: "ABI",
            ToolData: 'U.S. Customs&#8218;	 "Automated Broker Interface," by which brokers file importers&#8218; entries electronically',
        },
        {
            ToolName: "AMS",
            ToolData: 'Automated Manifest System.? An application that expedites the clearance of cargo for the subsequent release of containers when imported to the U.S. through electronic submission of cargo manifests in lieu of bulk paper manifests.?',
        },
        {
            ToolName: "Arrival notice",
            ToolData: 'An advice that the carrier sends to the consignee advising of goods coming forward for delivery. Pertinent information such as BL number, container number and total charges due from consignee etc, are included and sent to consignee prior to vessel arrival. This is done gratuitously by the carrier to ensure smooth delivery but there is no obligation by the carrier to do so. The responsibility to monitor the transit and present himself to take timely delivery still rests with the consignee.',
        },
        {
            ToolName: "Alex load",
            ToolData: 'Maximum load permitted to be carried on each axle of a motor vehicle.',
        },
        {
            ToolName: "BCO",
            ToolData: 'Abbreviation for "Beneficial Cargo Owner." Refers to the importer of record, who physically takes possession of cargo at destination and does not act as a third party in the movement of such goods.',
        },
        {
            ToolName: "Bill of landing(B/L)",
            ToolData: 'Official legal document representing ownership of cargo, a negotiable document to receive cargo, and the contract for cargo between the shipper and the carrier.',
        },
        {
            ToolName: "Blanket Waybill",
            ToolData: 'A waybill covering two or more consignments of freight.',
        },
        {
            ToolName: "Block trail",
            ToolData: 'Railcars grouped in a train by destination so that segments (blocks) can be uncoupled and routed to different destinations as the train moves through various junctions. Eliminates the need to break up a train and sort individual railcars at each junction.',
        },
        {
            ToolName: "Block trail",
            ToolData: 'Railcars grouped in a train by destination so that segments (blocks) can be uncoupled and routed to different destinations as the train moves through various junctions. Eliminates the need to break up a train and sort individual railcars at each junction.',
        },
        {
            ToolName: "BCO",
            ToolData: 'Abbreviation for "Beneficial Cargo Owner." Refers to the importer of record, who physically takes possession of cargo at destination and does not act as a third party in the movement of such goods.',
        },
        {
            ToolName: "Bill of landing(B/L)",
            ToolData: 'Official legal document representing ownership of cargo, a negotiable document to receive cargo, and the contract for cargo between the shipper and the carrier.',
        },
        {
            ToolName: "Blanket Waybill",
            ToolData: 'A waybill covering two or more consignments of freight.',
        },
        {
            ToolName: "Block trail",
            ToolData: 'Railcars grouped in a train by destination so that segments (blocks) can be uncoupled and routed to different destinations as the train moves through various junctions. Eliminates the need to break up a train and sort individual railcars at each junction.',
        },
        {
            ToolName: "Block trail",
            ToolData: 'Railcars grouped in a train by destination so that segments (blocks) can be uncoupled and routed to different destinations as the train moves through various junctions. Eliminates the need to break up a train and sort individual railcars at each junction.',
        },
        {
            ToolName: "Blanket Waybill",
            ToolData: 'A waybill covering two or more consignments of freight.',
        },
        {
            ToolName: "Block trail",
            ToolData: 'Railcars grouped in a train by destination so that segments (blocks) can be uncoupled and routed to different destinations as the train moves through various junctions. Eliminates the need to break up a train and sort individual railcars at each junction.',
        },
        {
            ToolName: "Block trail",
            ToolData: 'Railcars grouped in a train by destination so that segments (blocks) can be uncoupled and routed to different destinations as the train moves through various junctions. Eliminates the need to break up a train and sort individual railcars at each junction.',
        },
        {
            ToolName: "Blanket Waybill",
            ToolData: 'A waybill covering two or more consignments of freight.',
        },
        {
            ToolName: "Block trail",
            ToolData: 'Railcars grouped in a train by destination so that segments (blocks) can be uncoupled and routed to different destinations as the train moves through various junctions. Eliminates the need to break up a train and sort individual railcars at each junction.',
        },
        {
            ToolName: "Block trail",
            ToolData: 'Railcars grouped in a train by destination so that segments (blocks) can be uncoupled and routed to different destinations as the train moves through various junctions. Eliminates the need to break up a train and sort individual railcars at each junction.',
        },
    ];
    let ToolsList = [
        {
            ListId: 1,
            ListData: TotalData,
        },
        {
            ListId: 2,
            ListData: TotalData,
        },
        {
            ListId: 3,
            ListData: TotalData,
        },

    ]
    const handleButtonClick = (buttonId) => {
        setId(buttonId);
    };
    let active_data = ToolsList.find(obj => obj.ListId === id);
    const MoreData = () => {
        if (ShowData >= active_data.ListData.length) {
            ChangeShowData(ShowData - 5);
            ChangeBtnText("Show Less");
        } else {
            ChangeShowData(ShowData + 5);
            ChangeBtnText("Load More");
        }
    };
    let option1 = "Buyer";
    let option2 = "Seller";
    let TableData = [
        {
            incoterms: "EXW",
            ecd: option1,
            ctp2: option1,
            uot: option1,
            lcp: option1,
            cca: option1,
            ucp: option1,
            lat: option1,
            ctp: option1,
            insurance: option1,
            icd: option1,
            ut: option1,
        },
        {
            incoterms: "FCA",
            ecd: option2,
            ctp2: option1,
            uot: option1,
            lcp: option1,
            cca: option1,
            ucp: option1,
            lat: option1,
            ctp: option1,
            insurance: option1,
            icd: option1,
            ut: option1,
        }
        ,
        {
            incoterms: "FAS",
            ecd: option2,
            ctp2: option2,
            uot: option1,
            lcp: option1,
            cca: option1,
            ucp: option1,
            lat: option1,
            ctp: option1,
            insurance: option1,
            icd: option1,
            ut: option1,
        },
        {
            incoterms: "FOB",
            ecd: option2,
            ctp2: option2,
            uot: option2,
            lcp: option2,
            cca: option1,
            ucp: option1,
            lat: option1,
            ctp: option1,
            insurance: option1,
            icd: option1,
            ut: option1,
        },
        {
            incoterms: "CFR",
            ecd: option2,
            ctp2: option2,
            uot: option2,
            lcp: option2,
            cca: option2,
            ucp: option1,
            lat: option1,
            ctp: option1,
            insurance: option1,
            icd: option1,
            ut: option1,
        },
        {
            incoterms: "CIF",
            ecd: option2,
            ctp2: option2,
            uot: option2,
            lcp: option2,
            cca: option2,
            ucp: option2,
            lat: option1,
            ctp: option1,
            insurance: option1,
            icd: option1,
            ut: option1,
        },
        {
            incoterms: "CPT",
            ecd: option2,
            ctp2: option2,
            uot: option2,
            lcp: option2,
            cca: option2,
            ucp: option2,
            lat: option2,
            ctp: option1,
            insurance: option1,
            icd: option1,
            ut: option1,
        },
        {
            incoterms: "CIP",
            ecd: option2,
            ctp2: option2,
            uot: option2,
            lcp: option2,
            cca: option2,
            ucp: option2,
            lat: option2,
            ctp: option2,
            insurance: option1,
            icd: option1,
            ut: option1,
        },
        {
            incoterms: "DAT",
            ecd: option2,
            ctp2: option2,
            uot: option2,
            lcp: option2,
            cca: option2,
            ucp: option2,
            lat: option2,
            ctp: option2,
            insurance: option2,
            icd: option1,
            ut: option1,
        },
        {
            incoterms: "DAP",
            ecd: option2,
            ctp2: option2,
            uot: option2,
            lcp: option2,
            cca: option2,
            ucp: option2,
            lat: option2,
            ctp: option2,
            insurance: option2,
            icd: option2,
            ut: option1,
        },
        {
            incoterms: "DDP",
            ecd: option2,
            ctp2: option2,
            uot: option2,
            lcp: option2,
            cca: option2,
            ucp: option2,
            lat: option2,
            ctp: option2,
            insurance: option2,
            icd: option2,
            ut: option2,
        }
    ]

    return (
        <>
            <Header />
            {/* Tools Section Start Here */}
            <section className="tools-section pb-5">
                <div className="container">
                    <div className="tools-sections-start">
                        <div className="top-heading text-center">
                            <h1 className="lg-heading mt-5 ">Tools</h1>
                        </div>
                        <ul className="tools-list mt-4">
                            {
                                NameList.map((SingleName, index) => (
                                    <li className="list-items"><button className={(index + 1 == id) ? "tool-btn  active" : "tool-btn "} onClick={() => handleButtonClick(SingleName.TheId)}>{SingleName.TheName}</button></li>
                                ))
                            }
                        </ul>
                        {active_data.ListId === 3 && (
                            <>
                                <div className="col-xl-10 col-lg-11 mx-auto">
                                    <ul className="box-list mt-4">
                                        {
                                            active_data.ListData.slice(0, ShowData).map((SingleTool, index) => (
                                                <li className="single-box" key={index}>
                                                    <div className="box-name primary-text">
                                                        <span className="md-text">{SingleTool.ToolName}</span>
                                                    </div>
                                                    <div className="box-text">
                                                        <p className="text mb-0">{SingleTool.ToolData}</p>
                                                    </div>
                                                </li>
                                            ))
                                        }
                                    </ul>
                                    <div className="text-center mt-4 pb-4">
                                        <button className="btn" onClick={MoreData}>{BtnText}</button>
                                    </div>
                                </div>
                            </>
                        )}
                        {active_data.ListId === 2 && (
                            <>
                                <div className="converter-tools-start">
                                    <div className="step-boxes">
                                        <p className='text text-center'>Use our tools for easy methods of converting weight, currency and volume for all your shipments,</p>
                                        <div className="steps">
                                            <div className="row">
                                                <div className="col-lg-4 col-md-6">
                                                    <div className="single-step">
                                                        <figure className="icon">
                                                            <img src={Step1Icon} alt="" className="the-icon" />
                                                        </figure>
                                                        <div className="text-here">
                                                            <h4 className="sm-heading">Step 1</h4>
                                                            <p className="md-text crop-2-lines">Select a transportation method.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6">

                                                    <div className="single-step">
                                                        <figure className="icon">
                                                            <img src={Step2Icon} alt="" className="the-icon" />
                                                        </figure>
                                                        <div className="text-here">
                                                            <h4 className="sm-heading">Step 2</h4>
                                                            <p className="md-text crop-2-lines">Enter the number of pieces, length, width, and height.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6">
                                                    <div className="single-step">
                                                        <figure className="icon">
                                                            <img src={Step3Icon} alt="" className="the-icon" />
                                                        </figure>
                                                        <div className="text-here">
                                                            <h4 className="sm-heading">Step 3</h4>
                                                            <p className="md-text crop-2-lines">Click the "Perform Calculation" button.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="weight-calculator">
                                    <div className="row align-items-center">
                                        <div className="col-lg-5 col-md-6 pe-xl-0">
                                            <div className="calcutlator-text">
                                                <h2 className="md-heading">Dimensional Weight Calculator</h2>
                                                <div className="text-here mt-4">
                                                    <p className="text">To use the simple calculator below, select which type you would like to calculate and enter (in whole numbers) your pieces, weight and dimensions and press "calculate" to find the dimensional weight of your package.</p>
                                                    <p className='text'>For International Air Shipment: Length X Width X Height ÷ 166 = Dim Weight <br />
                                                        (Example in inches: 47in X 40in X 40in ÷ 166 = 453lbs) <br />
                                                        (Example in centimeters: 120cm X 102cm X 102cm ÷ 6000 = 208kgs</p>
                                                    <p className="text">For International Ocean Shipment: Length X Width X Height ÷ 1728/35.32 = Cubic Meter
                                                        (Example: 47in X 40in X 40in ÷ 1728 / 35.32 = 1.232 m3)</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-7 col-md-6 ps-xl-4">
                                            <div className="weight-calculator-form">
                                                <form className='custom-from'>
                                                    <div className="row">
                                                        <div className="col-lg-6 mt-3">
                                                            <div className="form-group">
                                                                <label htmlFor="" className="custom-label">Total Pieces</label>
                                                                <input type="text" className="form-control" name='' id='' placeholder='Total Pieces' />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 mt-3">
                                                            <div className="form-group">
                                                                <label htmlFor="" className="custom-label">Length</label>
                                                                <input type="text" className="form-control" name='' id='' placeholder='Length' />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 mt-3">
                                                            <div className="form-group">
                                                                <label htmlFor="" className="custom-label">Width</label>
                                                                <input type="text" className="form-control" name='' id='' placeholder='Width' />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 mt-3">
                                                            <div className="form-group">
                                                                <label htmlFor="" className="custom-label">Height</label>
                                                                <input type="text" className="form-control" name='' id='' placeholder='Height' />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 mt-3">
                                                            <div className="form-group">
                                                                <label htmlFor="" className="custom-label">Actual Weight (lbs)</label>
                                                                <input type="text" className="form-control" name='' id='' placeholder='Actual Weight (lbs)' />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 mt-3">
                                                            <div className="form-group">
                                                                <label htmlFor="" className="custom-label d-block">Select Measurement type</label>
                                                                <div className="form-flex d-flex gap-3 gap-lg-4 mt-3 pt-1">
                                                                    <div className="single-check">
                                                                        <input type="radio" id="centimeter" className='custom-radio' name="size" />
                                                                        <label for="centimeter" className="custom-radio-label">Centimeters</label>
                                                                    </div>
                                                                    <div className="single-check">
                                                                        <input type="radio" id="inches" className='custom-radio' name="size" checked />
                                                                        <label for="inches" className="custom-radio-label">Inches</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 mt-3">
                                                            <div className="form-group">
                                                                <label htmlFor="" className="custom-label d-block">Select Weight type</label>
                                                                <div className="form-flex d-flex gap-3 gap-lg-4 mt-3 pt-1">
                                                                    <div className="single-check">
                                                                        <input type="radio" id="kg" className='custom-radio' name="weight" />
                                                                        <label for="kg" className="custom-radio-label">Kilograms</label>
                                                                    </div>
                                                                    <div className="single-check">
                                                                        <input type="radio" id="pounds" className='custom-radio' name="weight" checked />
                                                                        <label for="pounds" className="custom-radio-label">Pounds</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6"></div>
                                                        <div className="col-lg-3 col-md-6 mt-4">
                                                            <label htmlFor="" className='opacity-0'>.</label>
                                                            <button className="primar-btn btn w-100">Calculate</button>
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 mt-4">
                                                            <label htmlFor="" className='opacity-0'>.</label>
                                                            <button className="primar-btn btn w-100">Reset</button>
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 mt-4">
                                                            <label htmlFor="" className='custom-label d-block'>Dimensional weight</label>
                                                            {/* <button className=""></button> */}
                                                            <input type="text" name="" id="" className=' form-control transparent-btn w-100 px-0' placeholder='Dimensional weight' />
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 mt-4">
                                                            <label htmlFor="" className='custom-label d-block'>Density</label>
                                                            {/* <button className="btn transparent-btn w-100 px-0">Density</button> */}
                                                            <input type="text" name="" id="" className=' form-control transparent-btn w-100 px-0' placeholder='Density' />
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="weight-cconversion">
                                    <div className="row align-items-center">
                                        <div className="col-lg-7 col-md-6 pe-lg-5 order-1 order-md-0 mt-5 mt-md-0">
                                            <div className="alternate-form me-lg-2">
                                                <form className='custom-from py-4'>
                                                    <div className="row py-lg-3">
                                                        <h6 className="xs-heading mb-0">From Pounds to Kilograms</h6>
                                                        <div className="col-lg-6 col-md-12 mt-3">
                                                            <div className="form-group">
                                                                <label htmlFor="" className="custom-label">Lbs</label>
                                                                <input type="text" className="form-control" name='' id='' placeholder='Lbs' />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-md-12 mt-3">
                                                            <div className="form-group">
                                                                <label htmlFor="" className="custom-label">Kgs</label>
                                                                <input type="text" className="form-control" name='' id='' placeholder='Kgs' />
                                                            </div>
                                                        </div>
                                                        <h6 className="xs-heading mt-5 mb-0">From Kilograms to Pounds</h6>
                                                        <div className="col-lg-6 col-md-12 mt-3">
                                                            <div className="form-group">
                                                                <label htmlFor="" className="custom-label">Lbs</label>
                                                                <input type="text" className="form-control" name='' id='' placeholder='Lbs' />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-md-12 mt-3">
                                                            <div className="form-group">
                                                                <label htmlFor="" className="custom-label">Kgs</label>
                                                                <input type="text" className="form-control" name='' id='' placeholder='Kgs' />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12 mt-3">
                                                            <button className="btn w-100">Reset</button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                        <div className="col-lg-5 col-md-6 ps-lg-0 order-0 order-md-1">
                                            <div className="convversion-text primary-text">
                                                <h2 className="md-heading">Weight Conversion Calculator</h2>
                                                <div className="single-example mt-4">
                                                    <h6 className="xs-heading">Example</h6>
                                                    <p className='text'>To convert 1250lbs to kgs, you would divide 1250 by 2.2046. <br />
                                                        (1250 ÷ 2.2046 = 567kgs)</p>
                                                    <p className='text'>To convert 125.5kgs to lbs, you would multiply 125.5 by 2.2046.<br />
                                                        (125.5 X 2.2046 = 276.68)</p>
                                                </div>
                                                <div className="single-example mt-5">
                                                    <h6 className="xs-heading">Instructions</h6>
                                                    <p className='text'>Enter the weight on the left side and click the arrow to convert from pounds to kilograms or vice-versa</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="currency-convrsion-start py-5">
                                    <div className="row pt-2  align-items-center">
                                        <div className="col-lg-5 col-md-6 pe-lg-0">
                                            <div className="currency-converion-text">
                                                <h2 className="md-heading">Currency Conversion Calculator</h2>
                                                <div className="text-here">
                                                    <h6 className="xs-heading mt-4">Example</h6>
                                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-7 col-md-6 ps-lg-5">
                                            <div className="coversion-form">
                                                <form className='custom-from'>
                                                    <div className="row">
                                                        
                                                        <div className="col-lg-6 col-md-12 mt-3">
                                                            <div className="form-group">
                                                                <label htmlFor="" className="custom-label">From</label>
                                                                <select className="form-control" name='' id=''>
                                                                    <option value="America (United States) Dollars - USD">America (United States) Dollars - USD</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-md-12 mt-3">
                                                            <div className="form-group">
                                                                <label htmlFor="" className="custom-label">To</label>
                                                                <select className="form-control" name='' id=''>
                                                                    <option value="Canada Dollars - USD">Canada Dollars - USD</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mt-3">
                                                            <div className="form-group">
                                                                <label htmlFor="" className="custom-label">Amount</label>
                                                                <input type="text" className="form-control" name='' id='' placeholder='1' />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mt-3">
                                                            <div className="form-group">
                                                                <label htmlFor="" className="custom-label">Converted Amount</label>
                                                                <input type="text" className="form-control" name='' id='' placeholder='' value={"28,738.504"} />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-md-12 mt-4">
                                                            <span className="btn transparent-btn w-100 px-0">Convert</span>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                        {active_data.ListId === 1 && (
                            <>
                                <div className="incoterms-table-start">
                                    <table className='incoterms-table'>
                                        <thead className="table-head">
                                            <tr className='head-row'>
                                                <td className='normal-td td-head'>Incoterm 2010</td>
                                                <td className='normal-td td-head'>Export Customs Declaration</td>
                                                <td className='normal-td td-head'>Carriage to port of export</td>
                                                <td className='normal-td td-head'>Unloading of Truck In port of Export</td>
                                                <td className='normal-td td-head'>Loading Charges in port of export</td>
                                                <td className='normal-td td-head'>Carriage (Sea Freight /Air fright) To Port Of Import</td>
                                                <td className='normal-td td-head'>Unloading Charges in port of import</td>
                                                <td className='normal-td td-head'>Loading An Truck In port Of Import</td>
                                                <td className='normal-td td-head'>Carriage to Place of Destination</td>
                                                <td className='normal-td td-head'>Insurance</td>
                                                <td className='normal-td td-head'>Import Customs Dearance</td>
                                                <td className='normal-td td-head'>Import Taxes</td>
                                            </tr>
                                        </thead>
                                        <tbody className="table-body">
                                            {
                                                TableData.map((data, index) => (
                                                    <>
                                                        <tr key={index}>
                                                            <td className='normal-td td-head data-name'>{Object.values(data)[0]}</td>

                                                            <td className={(data.ecd == "Buyer") ? "normal-td text" : "normal-td text seller"}>{data.icd}</td>
                                                            <td className={(data.ctp2 == "Buyer") ? "normal-td text" : "normal-td text seller"}>{data.ctp2}</td>
                                                            <td className={(data.uot == "Buyer") ? "normal-td text" : "normal-td text seller"}>{data.uot}</td>
                                                            <td className={(data.lcp == "Buyer") ? "normal-td text" : "normal-td text seller"}>{data.lcp}</td>
                                                            <td className={(data.cca == "Buyer") ? "normal-td text" : "normal-td text seller"}>{data.cca}</td>
                                                            <td className={(data.ucp == "Buyer") ? "normal-td text" : "normal-td text seller"}>{data.ucp}</td>
                                                            <td className={(data.lat == "Buyer") ? "normal-td text" : "normal-td text seller"}>{data.lat}</td>
                                                            <td className={(data.ctp == "Buyer") ? "normal-td text" : "normal-td text seller"}>{data.ctp}</td>
                                                            <td className={(data.insurance == "Buyer") ? "normal-td text" : "normal-td text seller"}>{data.insurance}</td>
                                                            <td className={(data.icd == "Buyer") ? "normal-td text" : "normal-td text seller"}>{data.icd}</td>
                                                            <td className={(data.ut == "Buyer") ? "normal-td text" : "normal-td text seller"}>{data.ut}</td>
                                                        </tr>
                                                    </>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        )}
                        {/* Add more if statements for additional conditions */}
                    </div>
                </div>
            </section >
            {/* Tools Section End Here */}
            {/* Footer Included Here */}
            <Footer />
            {/* Footer Included Here */}
        </>
    )
}
export default Tools;